<ng-container *ngIf="alert$ | async as alert"></ng-container>
